'use client';
import Logo from 'components/generic-components/Logo';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { AuthRoutes } from 'routes';
import Button from './Button';

export default function TheraStartNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    const handleRouteChange = () => {
      setIsMenuOpen(false);
    };

    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-30 flex w-full items-center justify-between bg-white px-[1rem] py-[1rem] text-black transition-all duration-300 md:px-[4rem] ${
        isScrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="flex items-center gap-[0.125rem]">
        {/* Logo */}
        <Link href="/" prefetch={false}>
          <div className="relative h-[2.5rem] w-[3rem]">
            <Logo useImage={true} className="object-contain" priority sizes="(max-width: 768px) 56px, 56px" />
          </div>
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="relative flex h-[2.5rem] w-[2.5rem] items-center justify-center p-[0.5rem] md:hidden"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
        aria-expanded={isMenuOpen}
      >
        <div className="relative h-[1.5rem] w-[1.5rem]">
          <span
            className={`absolute h-[0.125rem] w-[1.5rem] transform bg-black transition-all duration-300 ease-in-out ${
              isMenuOpen ? 'top-[0.75rem] rotate-45' : 'top-[0.25rem]'
            }`}
          />
          <span
            className={`absolute top-[0.75rem] h-[0.125rem] w-[1.5rem] bg-black transition-all duration-300 ease-in-out ${
              isMenuOpen ? 'opacity-0' : 'opacity-100'
            }`}
          />
          <span
            className={`absolute h-[0.125rem] w-[1.5rem] transform bg-black transition-all duration-300 ease-in-out ${
              isMenuOpen ? 'top-[0.75rem] -rotate-45' : 'top-[1.25rem]'
            }`}
          />
        </div>
      </button>

      {/* Desktop Navigation */}
      <div className="hidden gap-[2rem] text-[0.93rem] font-medium text-dark md:flex" style={{ lineHeight: '1.6' }}>
        <Link href={AuthRoutes.TheraStart} className="transition hover:text-therablue">
          Get Incorporated
        </Link>
        <a
          href="https://www.getthera.com/why-thera"
          target="_blank"
          rel="noopener noreferrer"
          className="transition hover:text-therablue"
        >
          About
        </a>
        {/* <a href="#cta" className="transition hover:text-therablue">
          Contact Us
        </a> */}
      </div>

      {/* Desktop CTA Button */}
      <div className="hidden md:block">
        <Link href={AuthRoutes.TheraStart}>
          <Button
            variant="primary"
            size="md"
            className="!bg-[#333333] text-[0.83rem] font-[300] transition hover:!bg-therablue"
          >
            Incorporate
          </Button>
        </Link>
      </div>

      {/* Mobile Navigation Menu */}
      <div
        className={`fixed left-0 top-[4.5rem] w-full bg-white shadow-lg transition-all duration-300 ease-in-out md:hidden ${
          isMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
        }`}
        role="navigation"
        aria-label="Mobile menu"
      >
        <div className="flex flex-col gap-[1rem] p-[1rem]">
          <Link
            href={AuthRoutes.TheraStart}
            className="py-[0.5rem] text-[0.94rem] font-[500] transition hover:text-therablue"
            onClick={() => setIsMenuOpen(false)}
          >
            Get Incorporated
          </Link>
          <a
            href="https://www.getthera.com/why-thera"
            target="_blank"
            rel="noopener noreferrer"
            className="py-[0.5rem] text-[0.94rem] font-[500] transition hover:text-therablue"
            onClick={() => setIsMenuOpen(false)}
          >
            About
          </a>
          {/* <a
            href="#cta"
            className="py-[0.5rem] text-[0.94rem] font-[500] transition hover:text-therablue"
            onClick={() => setIsMenuOpen(false)}
          >
            Contact Us
          </a> */}
          <Link href={AuthRoutes.TheraStart} onClick={() => setIsMenuOpen(false)}>
            <Button
              variant="primary"
              className="w-full !bg-[#333333] text-[0.875rem] font-[400] transition hover:!bg-therablue"
            >
              Incorporate
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  );
}
